import { render } from "./UN.vue?vue&type=template&id=7473b665"
import script from "./UN.vue?vue&type=script&lang=js"
export * from "./UN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__